// JsFromRoutes CacheKey 5776af17e5b2ffd47a5fff5da5811bc0
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  updatePreferredPlaybackRate: /* #__PURE__ */ definePathHelper('post', '/user/update_preferred_playback_rate'),
  updatePlaybackPosition: /* #__PURE__ */ definePathHelper('post', '/user/update_playback_position'),
}
